export const updateProductPrice = () => {
  jQuery(document).ready(function ($) {
    $("form.variations_form").on(
      "found_variation",
      function (event, variation) {
        if (variation && variation.price_html) {
          $(".woocommerce-variation-price").html(variation.price_html);
        }
      }
    );
  });
};
